module.exports = __webpack_public_path__ + "static/media/logo.fe6ed5bf.png";